
import { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import TatDetails from "./TatDetails";
import Footer from "../../../core/common/Footer";
import SearchableSelect from "../../../core/common/SearchableSelect";
import useProjects from "../../../core/customhook/useProjects";
import "./TatAndPricing.css";
const TatAndPricing = () => {
  const [showGuide, setShowGuide] = useState<boolean>(true);
  const [tabSwitch, setTabSwitch] = useState("TATDetails");
  const { projects, loading } = useProjects();

  const [filterData, setFilterData] = useState({
    project_id: "",
  });

  const handleFieldDataChange = (name: string, value: string | number) => {
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const tabs = [
    {
      key: "TATDetails",
      label: "TAT Details",
      component: TatDetails,
    },
  ];

  const SelectedTab = tabs.find((tab) => tab.key === tabSwitch)?.component;

  return (
    <div className="page-wrapper tat-pricing-page">
      <div className="content">
        {/* Page Header */}
        <div className="tat-page-header">
          <div className="d-flex align-items-start gap-3">
            <div className="tat-header-icon">
              <i className="ti ti-settings-cog" />
            </div>

            <div className="my-auto">
              <h2 className="tat-page-title">TAT Configuration</h2>

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb tat-breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.superAdminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Account Activation</li>
                  <li className="breadcrumb-item active">
                    TAT Configuration
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="tat-header-actions">
            <span className="tat-status">
              <span className="tat-status-dot" />
              Configuration
            </span>
            <CollapseHeader />
          </div>
        </div>

        {/* Guide Toggle */}
        <div className="tat-guide-toolbar">
          <div className="tat-guide-caption">
            <i className="ti ti-info-circle" />
            <span>Need help configuring TAT?</span>
          </div>

          <button
            type="button"
            className={`tat-guide-toggle ${
              showGuide ? "active" : ""
            }`}
            onClick={() => setShowGuide((prev) => !prev)}
            aria-expanded={showGuide}
          >
            <i
              className={`ti ${
                showGuide ? "ti-eye-off" : "ti-info-circle"
              }`}
            />
            {showGuide ? "Hide Guide" : "View Guide"}
            <i
              className={`ti ${
                showGuide ? "ti-chevron-up" : "ti-chevron-down"
              }`}
            />
          </button>
        </div>

        {/* Guide Panel */}
        <div
          className={`tat-guide-wrapper ${
            showGuide ? "is-open" : "is-closed"
          }`}
          aria-hidden={!showGuide}
        >
          {showGuide && (
            <div className="tat-guide-card">
              <div className="tat-guide-icon">
                <i className="ti ti-bulb" />
              </div>

              <div className="tat-guide-content">
                <h5>Turnaround Time (TAT)</h5>
                <p>
                  Configure turnaround time settings to define how long
                  processing activities should take within the system.
                  Select a brand below to manage its TAT configuration.
                </p>
              </div>

              <button
                type="button"
                className="tat-guide-close"
                onClick={() => setShowGuide(false)}
                aria-label="Close guide"
              >
                <i className="ti ti-x" />
              </button>
            </div>
          )}
        </div>

        {/* Project Selection */}
        <div className="tat-selection-card">
          <div className="tat-section-heading">
            <div className="tat-section-icon">
              <i className="ti ti-building-store" />
            </div>

            <div>
              <h5>Select Brand</h5>
              <p>Select a brand to view and manage its turnaround time settings.</p>
            </div>
          </div>

          <div className="tat-selection-body">
            <div className="row g-3 align-items-end">
              <div className="col-12 col-md-6 col-lg-5">
                <SearchableSelect
                  label="Brand Name"
                  name="project_id"
                  value={filterData?.project_id}
                  options={projects.map((item: any) => ({
                    label: item.project_name,
                    value: item.project_id,
                  }))}
                  onChange={handleFieldDataChange}
                  hasRowGrid={false}
                  required
                />
              </div>
 
            </div>
          </div>
        </div>

        {/* Configuration Tabs */}
        <div className="tat-tabs-section">
          <div className="tat-tabs-heading">
            <div>
              <h5>TAT Settings</h5>
              <p>View and configure turnaround time settings for the selected brand.</p>
            </div>

            <span className="tat-tab-count">
              {tabs.length} {tabs.length === 1 ? "Section" : "Sections"}
            </span>
          </div>

          <div className="tat-tabs-nav" role="tablist">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={tabSwitch === tab.key}
                className={`tat-tab-btn ${
                  tabSwitch === tab.key ? "active" : ""
                }`}
                onClick={() => setTabSwitch(tab.key)}
              >
                <i className="ti ti-clock-cog" />
                <span>{tab.label}</span>
                <i className="ti ti-chevron-right tat-tab-arrow" />
              </button>
            ))}
          </div>
        </div>

        {/* Selected Tab Content */}
        {SelectedTab && (
          <div className="tat-tab-content">
            <SelectedTab projectId={filterData.project_id} />
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default TatAndPricing;



// import { useState } from "react";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import TatDetails from "./TatDetails";
// import Footer from "../../../core/common/Footer";
// import SearchableSelect from "../../../core/common/SearchableSelect";
// import useProjects from "../../../core/customhook/useProjects";

// const TatAndPricing = () => {
//   const [showGuide, setShowGuide] = useState<boolean>(true);
//   const [tabSwitch, setTabSwitch] = useState("TATDetails");
//   const { projects, loading } = useProjects();

//   const [filterData, setFilterData] = useState({
//     project_id: "",
//   });

//   const handleFieldDataChange = (name: string, value: string | number) => {
//     setFilterData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const tabs = [
//     {
//       key: "TATDetails",
//       label: "TAT Details",
//       component: TatDetails,
//     },
//     // {
//     //   key: "InterimSetting",
//     //   label: "Interim Setting",
//     //   component: InterimSetting,
//     // },
//     // {
//     //   key: "ComponentWisePricing",
//     //   label: "Check Wise Pricing",
//     //   component: ComponentWisePricing,
//     // },
//     // {
//     //   key: "PackageWisePricing",
//     //   label: "Package Wise Pricing",
//     //   component: PackageWisePricing,
//     // },
//     // {
//     //   key: "ChoosePostBgvChecks",
//     //   label: "Choose Post BGV Checks",
//     //   component: ChoosePostBgvChecks,
//     // },
//   ];

//   const SelectedTab = tabs.find((tab) => tab.key === tabSwitch)?.component;

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         {/* Breadcrumb */}
//         <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//           <div className="my-auto mb-2">
//             <h2 className="mb-1">TAT Configuration</h2>
//             <nav>
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-item">
//                   <Link to={all_routes.superAdminDashboard}>
//                     <i className="ti ti-smart-home" />
//                   </Link>
//                 </li>
//                 <li className="breadcrumb-item">Account Activation</li>
//                 <li className="breadcrumb-item active">TAT Configuration</li>
//               </ol>
//             </nav>
//           </div>
//           <div className="head-icons ms-2">
//             <CollapseHeader />
//           </div>
//         </div>

//         <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center mt-3">
//           <button
//             className="btn border bg-white px-3"
//             onClick={() => setShowGuide((prev) => !prev)}
//           >
//             <i className="ti ti-info-circle-filled fs-16"></i> Guide
//           </button>
//         </div>

//         {showGuide && (
//           <div
//             style={{
//               overflow: "hidden",
//               maxHeight: showGuide ? "500px" : "0px",
//               transition: "all 0.4s ease",
//             }}
//           >
//             {/* Top Arrow */}
//             <div className="text-end pe-3">
//               <i
//                 className="ti ti-triangle-inverted-filled"
//                 style={{
//                   fontSize: "22px",
//                   color: "#cfcfcf",
//                   lineHeight: 0,
//                 }}
//               ></i>
//             </div>

//             {/* Guide Box */}
//             <div
//               className="card border-0 shadow-sm"
//               style={{
//                 borderRadius: "4px",
//               }}
//             >
//               <div className="card-body position-relative p-4">
//                 {/* Close Button */}
//                 <div className="position-absolute top-0 end-0 mt-3 me-3">
//                   <i
//                     className="ti ti-x"
//                     style={{
//                       background: "#6c757d",
//                       color: "#fff",
//                       borderRadius: "50%",
//                       width: "20px",
//                       height: "20px",
//                       fontSize: "12px",
//                       cursor: "pointer",
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                     onClick={() => setShowGuide(false)}
//                   ></i>
//                 </div>

//                 {/* Heading */}
//                 <h5 className="fw-bold mb-0">TAT</h5>

//                 {/* Paragraph */}
//                 <p className="m-0 text-muted" style={{ lineHeight: "1.7" }}>
//                   All the turn around settings should be inserted into the
//                   system.
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="card border-0 shadow-sm">
//           <div className="card-body">
//             <div className="row g-3">
//               <div className="col-md-4">
//                 <SearchableSelect
//                   label="Select Brand Name"
//                   name="project_id"
//                   value={filterData?.project_id}
//                   options={projects.map((item: any) => ({
//                     label: item.project_name,
//                     value: item.project_id,
//                   }))}
//                   onChange={handleFieldDataChange}
//                   hasRowGrid={false}
//                   required
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="d-flex flex-wrap gap-2 my-3">
//           {tabs.map((tab) => (
//             <button
//               key={tab.key}
//               className={`btn ${
//                 tabSwitch === tab.key ? "btn-primary" : "btn-outline-primary"
//               }`}
//               onClick={() => setTabSwitch(tab.key)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>

//         {SelectedTab && <SelectedTab projectId={filterData.project_id} />}
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default TatAndPricing;